import autosaveService from './common/services/AutosaveService';


$(document).on('ajax:send', '.destroy-pre-entity', () => {
    autosaveService.activateAnimation();
    autosaveService.saveStarted();
});
$(document).on('ajax:complete', '.destroy-pre-entity', (event) => {
    autosaveService.saveFinished();
    let $element = $(event.target);
    let $card = $element.closest('fieldset.card');
    $card.slideUp(500, () =>{
        $card.remove();
        $(document).trigger('fieldChange');

    });

    $("div#additionalEntities").find("input[type=hidden]").each(function(i, input){
        let $input = $(input);
        if($input.val() == $element.data("id")){
            $input.remove()
        }
    });

    $(document).trigger('card:destroyed');

});





$(document).on('ajax:send', '.destroy-nested-object .destroy-additional-lobbyist', () => {
    autosaveService.activateAnimation();
    autosaveService.saveStarted();
});
$(document).on('ajax:complete', '.destroy-additional-lobbyist', (event) => {
    autosaveService.saveFinished();
    let $element = $(event.target);
    let $card = $element.closest('fieldset.card');
    $card.slideUp(500, () =>{
        $card.remove();
        $(document).trigger('fieldChange');

    });

    $(document).trigger('card:destroyed');

});